/**
 * ChartLegend — 카드 헤더 우측에 배치되는 공용 범례.
 * dataset 이름만 표시. 좌/우축·값 표시는 tooltip에서 제공.
 * focusEnabled=true 시 hover로 다른 series dim.
 */
export interface ChartLegendItem {
  code: string;
  name: string;
  color: string;
}

export function ChartLegend({
  items,
  focusedCode,
  onHover,
  focusEnabled,
}: {
  items: ChartLegendItem[];
  focusedCode?: string | null;
  onHover?: (code: string | null) => void;
  focusEnabled?: boolean;
}) {
  if (items.length === 0) return null;
  return (
    <div className="chart-legend">
      {items.map((it) => {
        const dim = focusedCode != null && focusedCode !== it.code;
        return (
          <span
            key={it.code}
            className={`chart-legend-item ${focusEnabled ? "is-interactive" : ""} ${dim ? "is-dim" : ""}`}
            onMouseEnter={focusEnabled && onHover ? () => onHover(it.code) : undefined}
            onMouseLeave={focusEnabled && onHover ? () => onHover(null) : undefined}
          >
            <span className="chart-legend-dot" style={{ background: it.color }} />
            {it.name}
          </span>
        );
      })}
    </div>
  );
}
